<template functional>
    <button 
        class="m-tile-otg"
        type="button"
        @click="listeners.click(props.item)"
    >
        <span class="tile-otg-container">
            <span class="tile-otg-title">
                {{ props.item.name }}
            </span>
            <AAmountInfo
                :text="props.item.amountCategoriesText"
            />
        </span>
        <span
            v-if="props.item.files.icon"
            class="tile-otg-logo-wrapper"
        >
            <img :src="props.item.files.icon">
        </span>
    </button>
</template>

<script>
import AAmountInfo from '../../atoms/a-amount-info';

export default {
    name: 'MCategoryTile',
    components: {
        AAmountInfo
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        brandsName: {
            type: String,
            default: 'Merkevarer'
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
